import _ from 'lodash';
import '../styles.css';
import { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useApolloClient } from '@apollo/client';
import { useParams, useNavigate } from 'react-router-dom';
import { FETCH_OPERATIONS } from '../graphqlDefs/operations/mutations';
import {
  formatDate,
  getDateRangeForMonth,
  getMonthNames,
} from './utils/dateUtils';
import { getFilteredOperationsVariables } from './utils/filterOperationsVariables';
import { RENEW_OPERATION } from '../graphqlDefs/operations/mutations';
import Button from '@mui/material/Button';
import { MESSAGE } from '../constants/Message';
import {
  createQualityProperties,
  createContractValue,
} from './utils/contractRenewel';
import { PAGES } from '../constants/Pages';
import { getMessage } from '../translations';

const ContractApp = () => {
  const client = useApolloClient();
  const { id } = useParams();
  const licenseKey = process.env.REACT_APP_LICENSE_KEY;
  const [result, setResult] = useState(
    'Your output data will be displayed here'
  );
  const navigate = useNavigate();
  const [activeLoader, setActiveLoader] = useState(false);
  const [fetchingLoader, setFetchingLoader] = useState(true);
  const [insertedCount, setInsertedCount] = useState(0);
  const [nonInsertedCount, setNonInsertedCount] = useState(0);
  const [afterRenewelData, setAfterRenewelData] = useState([]);
  const [failedOperations, setFailedOperations] = useState([]);
  const handleGoBack = () => {
    navigate(`/${PAGES.CONTRACTSCREEN}`);
  };
  const [otherRef, monthVal, marketType] = id.split('&');
  const [confirmationOpen, setConfirmationOpen] = useState(false);

  const { startDate, endDate, newEndDate } = getDateRangeForMonth(monthVal);

  const { selectedMonth, renewedTobeMonthe } = getMonthNames(monthVal);
  const filteredOperationsVariables = getFilteredOperationsVariables(
    startDate,
    endDate,
    marketType
  );
  const { data, error } = useQuery(FETCH_OPERATIONS, {
    variables: filteredOperationsVariables,
  });
  const fetchData = () => {
    if (data !== '' || data !== undefined) {
      setFetchingLoader(false);
    }
  };
  const handleRenewal = () => {
    // Open the confirmation dialog
    setConfirmationOpen(true);
  };
  useEffect(() => {
    if (data !== undefined) {
      fetchData();
    }
  }, [data]);
  const handleConfirmRenewal = async () => {
    // Activate the loader
    setActiveLoader(true);
    // Perform the renewal operation
    const renewalResult = await renewContract(data);
    // Deactivate the loader
    setActiveLoader(false);
    setConfirmationOpen(false);
    // Set afterRenewelData with all successful operations
    setAfterRenewelData(renewalResult.successfulOperations);
    // Set failed operations
    setFailedOperations(renewalResult.failedOperations);
    // Update the counts
    setInsertedCount(renewalResult.successCount);
    setNonInsertedCount(renewalResult.errorCount);
  };

  const handleCancelRenewal = () => {
    setConfirmationOpen(false);
  };

  const renewContract = async (res) => {
    let successCount = 0;
    let errorCount = 0;
    let successfulOperations = [];
    let failedOperations = [];

    if (res.filteredOperations !== '' && res.filteredOperations.length > 0) {
      for (let i = 0; i < res.filteredOperations.length; i++) {
        const rItem = res.filteredOperations[i];
        const qualities = rItem.qualities || [];
        const qualityProperties = createQualityProperties(qualities);

        const contractValue = createContractValue(
          rItem,
          otherRef,
          qualityProperties,
          newEndDate
        );
        try {
          const { data } = await client.mutate({
            mutation: RENEW_OPERATION,
            variables: { input: contractValue },
          });
          successCount++;
          successfulOperations.push(data.renewOperation);
        } catch (error) {
          errorCount++;
          failedOperations.push(rItem.harold_number);
          console.error('Error updating post title:', error);
        }
      }
    }
    return { successfulOperations, successCount, errorCount, failedOperations };
  };

  useEffect(() => {
    console.log('afterRenewelData:', afterRenewelData);
  }, [afterRenewelData]);

  return activeLoader === true || fetchingLoader === true ? (
    <div
      className={
        activeLoader === true || fetchingLoader === true
          ? 'bgl-clr loading'
          : 'bgl-clr'
      }
    >
      <div className='loaderText'>
        {fetchingLoader === true ? (
          <p className=''>Fetching records </p>
        ) : (
          <p className=''>Renewing records </p>
        )}
        <span>
          <i></i>
          <i></i>
          <i></i>{' '}
        </span>
      </div>
    </div>
  ) : (
    <div className='App'>
      <div className='container-wrapper-contract'>
        <div>
          {data !== '' || data === undefined ? (
            <>
              <div className='segment-section'>
                <div className='segment-wrapper'>
                  <h2>Fetched Harold Numbers</h2>
                  <div style={{ height: 50 }}>
                    {/* {insertedCount > 0 && (
                      <p style={{ color: '#1dd51d' }}>
                        ( Records renewed successfully : {insertedCount} )
                      </p>
                    )} */}
                  </div>
                  <div className='data-segment'>
                    {data.filteredOperations.map((listD) => (
                      <p key={listD.harold_number}>{listD.harold_number}</p>
                    ))}
                  </div>
                </div>
                <div className='segment-wrapper'>
                  <h2>Renewed Harold Numbers</h2>
                  <div style={{ height: 50 }}>
                    {insertedCount > 0 && (
                      <p style={{ color: '#1dd51d' }}>
                        ( Records renewed successfully : {insertedCount} )
                      </p>
                    )}
                  </div>
                  <div className='data-segment'>
                    {afterRenewelData.length > 0 ? (
                      afterRenewelData.map((operation, index) => (
                        <p key={index}>{operation.harold_number}</p>
                      ))
                    ) : (
                      <p>---------</p>
                    )}
                  </div>
                </div>
                <div className='segment-wrapper'>
                  <h2>Unrenewed Harold Numbers</h2>
                  <div style={{ height: 50 }}>
                    {nonInsertedCount > 0 && (
                      <p style={{ color: 'red' }}>
                        ( Records not renewed [errors] : {nonInsertedCount} )
                      </p>
                    )}
                  </div>
                  <div className='data-segment'>
                    {failedOperations.length > 0 ? (
                      failedOperations.map((haroldNumber, index) => (
                        <p key={index}>{haroldNumber}</p>
                      ))
                    ) : (
                      <p>---------</p>
                    )}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
          <h1>
            {getMessage('RENEWING_TEXT')} {getMessage('FROM')} {selectedMonth}{' '}
            {getMessage('TO')} {renewedTobeMonthe}
          </h1>
          <div className='button FlexCenter'>
            <div className='import-btn' onClick={handleRenewal}>
              {getMessage('RENEW')}
            </div>
            <div className='import-btn' onClick={handleGoBack}>
              Go back
            </div>
          </div>
          {confirmationOpen && (
            <div className='overlay-box'>
              <div className='confirmation-dialog popup'>
                <a
                  className='close'
                  onClick={() => {
                    setConfirmationOpen(false);
                  }}
                >
                  <svg
                    className='sc-gsnTZi GjRDn MuiSvgIcon-root MuiSvgIcon-fontSizeMedium'
                    focusable='false'
                    viewBox='0 0 24 24'
                    aria-hidden='true'
                    data-testid='CloseIcon'
                  >
                    <path
                      d='M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 
                6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
                    ></path>
                  </svg>
                </a>
                <h4>{getMessage('CONFIRMATION_TEXT')}</h4>
                <div className='btnSectionConfBx'>
                  <Button variant='contained' onClick={handleConfirmRenewal}>
                    {getMessage('CONFIRMATION_YES')}
                  </Button>

                  <Button variant='contained' onClick={handleCancelRenewal}>
                    {getMessage('CONFIRMATION_NO')}
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContractApp;